import { render, staticRenderFns } from "./LpuCardsSortDialog.vue?vue&type=template&id=7bbbec32&scoped=true&"
import script from "./LpuCardsSortDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuCardsSortDialog.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LpuCardsSortDialog.vue?vue&type=style&index=0&id=7bbbec32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbbec32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bbbec32')) {
      api.createRecord('7bbbec32', component.options)
    } else {
      api.reload('7bbbec32', component.options)
    }
    module.hot.accept("./LpuCardsSortDialog.vue?vue&type=template&id=7bbbec32&scoped=true&", function () {
      api.rerender('7bbbec32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/LpuCardsSortDialog.vue"
export default component.exports